import React from 'react';
import Hero from '../components/Hero';
import TopDestinations from '../components/TopDestinations';
import InspiredTrips from '../components/InspiredTrips';
import BestOfCanary from '../components/BestOfCanary';
import WhyOWA from '../components/WhyOWA';
import Testimonials from '../components/Testimonials';
import Stories from '../components/Stories';
import SocialFeed from '../components/SocialFeed';
import Newsletter from '../components/Newsletter';
import Reveal from '../components/Reveal';

export default function Home() {
  return (
    <>
      <Hero />
      <Reveal><TopDestinations /></Reveal>
      <Reveal><InspiredTrips /></Reveal>
      <Reveal><WhyOWA /></Reveal>
      <Reveal><BestOfCanary /></Reveal>
      <Reveal><Testimonials /></Reveal>
      <Reveal><Stories /></Reveal>
      <Reveal><SocialFeed /></Reveal>
      <Reveal><Newsletter /></Reveal>
    </>
  );
}
